import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import FranchiseLocator from '../components/FranchiseLocator';
import FranchiseFullList from '../components/FranchiseFullList';
import { useGlobalWaLink } from '../contexts/SettingsContext';

const FranchiseLocatorPage = () => {
  const WA_LINK = useGlobalWaLink();
  const [searchParams] = useSearchParams();
  // When arriving with `?expanded=1` (i.e., the user clicked "Ver todas
  // as franquias" from the home), we DON'T want to force-scroll to the
  // top — the FranchiseFullList below will scrollIntoView itself.
  // Otherwise we anchor at the top so the map is visible.
  useEffect(() => {
    if (searchParams.get('expanded') !== '1') {
      window.scrollTo(0, 0);
    }
  }, [searchParams]);

  return (
    <>
      <SEO
        title="Localizador de Franquias — Instituto Eneagrama"
        description="Encontre a franquia do Instituto Eneagrama mais próxima de você. Filtre por país, estado e cidade no mapa interativo."
        path="/franquias"
      />
      <Header />
      <main className="min-h-screen">
        {/* PAGE HERO */}
        <section
          className="relative pt-32 pb-12 border-b border-neutral-900"
          style={{ background: 'rgba(10, 10, 10, 0.78)' }}
        >
          <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center">
            <span className="text-xs font-mono uppercase tracking-[0.3em] text-accent-orange mb-4 block">
              Rede IE Eneagrama
            </span>
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-[#EAEAEA] mb-4">
              Encontre o IE mais perto de você
            </h1>
            <p className="text-lg text-neutral-400 max-w-3xl mx-auto leading-[1.7]">
              Filtre pelo seu estado e cidade para descobrir a franquia ideal — ou veja todas
              as unidades certificadas no mapa interativo.
            </p>
          </div>
        </section>

        {/* LOCATOR (mapa) — protagonista da página */}
        <FranchiseLocator hideHeader />

        {/* FULL LIST — colapsada por padrão. Expandida via ?state=XX ou ?expanded=1 */}
        <FranchiseFullList />

        {/* CTA BAND */}
        <section
          className="relative py-20 border-t border-neutral-900"
          style={{ background: 'rgba(17, 17, 17, 0.78)' }}
        >
          <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
            <span className="text-xs font-mono uppercase tracking-[0.3em] text-accent-orange mb-3 block">
              Seja IE
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#EAEAEA] mb-4">
              Não encontrou uma franquia na sua região?
            </h2>
            <p className="text-base text-neutral-400 mb-8">
              O Instituto Eneagrama está expandindo. Conheça o modelo de franquia e leve a metodologia
              IE para a sua cidade.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="/franqueado"
                data-testid="franquias-page-cta-become"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-accent-orange text-white rounded-full text-sm font-bold uppercase tracking-wider hover:bg-[#E55D00] transition-colors"
              >
                <iconify-icon icon="solar:shop-2-linear" className="text-lg"></iconify-icon>
                Seja um franqueado
              </a>
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="franquias-page-cta-whatsapp"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 border border-[#333333] text-[#EAEAEA] rounded-full text-sm font-bold uppercase tracking-wider hover:border-accent-orange hover:text-accent-orange transition-colors"
              >
                <iconify-icon icon="mdi:whatsapp" className="text-lg"></iconify-icon>
                Falar com a sede
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default FranchiseLocatorPage;
